// Chat scroll behavior handler - 39 lines ✅
import { useEffect, useRef } from 'react'

interface ChatScrollHandlerProps<T = { role: string; content: string; timestamp: string }> {
  children: React.ReactNode
  messages: T[]
  isTyping: boolean
  className?: string
}

export function ChatScrollHandler<T = { role: string; content: string; timestamp: string }>({
  children,
  messages,
  isTyping,
  className,
}: ChatScrollHandlerProps<T>): JSX.Element {
  const scrollRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (scrollRef.current) {
      const lastMessage = scrollRef.current.lastElementChild
      if (lastMessage) {
        lastMessage.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        })
      }
    }
  }, [messages, isTyping])

  return (
    <div
      ref={scrollRef}
      className={className}
      role="log"
      aria-live="polite"
      aria-atomic="false"
    >
      {children}
    </div>
  )
}
